export const config = {
	apiKey: "AIzaSyBRHS_VbkcgI-sfLT9Ijwb4JyJ8w3jVtdA",
	authDomain: "soleol-webapp.firebaseapp.com",
	databaseURL: "https://soleol-webapp.firebaseio.com",
	projectId: "soleol-webapp",
	storageBucket: "soleol-webapp.appspot.com",
	messagingSenderId: "624742887618"
}



// WEBPACK FOOTER //
// ./src/firebase/config.js